import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../actions";
import { auth } from "../config";
import { db, increment, setDoc } from "../firestore";
import { Provider } from "../hooks";

import logo from "../img/o_logo.svg";
import Auth from "./Auth";

const Login = props => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.login.user);
    useEffect(
        () =>
            auth.onAuthStateChanged(async user => {
                if (!user) return;
                const doc = await db.collection("users").doc(user.uid).get();
                const userData = { id: user.uid, email: user.email, name: user.displayName };
                if (doc.exists) {
                    await dispatch(login({ user: Object.assign(userData, doc.data()) }));
                    await setDoc(
                        db.collection("users").doc(user.uid),
                        Object.assign(doc.data(), { lastLogin: Date.now() })
                    );
                    return;
                }
                await setDoc(db.collection("users").doc(user.uid), userData);
                await db.collection("stats").doc("users").set({ count: increment }, { merge: true });
                await dispatch(login({ user: userData }));
            }),
        [dispatch]
    );
    if (!user)
        return (
            <>
                <img src={logo} style={{ objectFit: "contain", display: "block" }} height={100} alt="" />
                <Auth />
            </>
        );
    return <Provider>{props.children}</Provider>;
};

export default Login;
